import React from 'react';
import "./StoryGeneratorProgress.css"

export type StoryGenerationProgress = "idle" | "waitForChatGPT" | "uploadingStoryCards" | "creatingStory";

interface ProgressProps {
  progress: StoryGenerationProgress;
}

const StoryGeneratorProgress: React.FC<ProgressProps> = ({ progress }) => {
  switch (progress) {
    case "idle":
      return null;
    case "waitForChatGPT":
    case "uploadingStoryCards":
    case "creatingStory":
      const description = {
        waitForChatGPT: "Waiting for ChatGPT response...",
        uploadingStoryCards: "Uploading story cards to DatoCMS...",
        creatingStory: "Creating your story..."
      }[progress];

      return (
        <div>
          <div className="progress-container">
            <div className="progress-bar moving"></div>
          </div>
          <p className="progress-description">{description}</p>
        </div>
      );
    default:
      return null;
  }
};

export default StoryGeneratorProgress;